<template>
  <div class="index-rottame">
    <keep-alive>
      <router-view :contenitoreHeight="contenitoreHeight"></router-view>
    </keep-alive>

    <div class="dashboard" :style="{ height: (contenitoreHeight + 35) + 'px' }" v-if="showDashboard">

      <div class="row row-custom">
        <div class="col-8">
          <div class="range-conferme">
            {{ rangeConfermeDa + ' - ' + rangeConfermeA }}
            <span class="localita">
              {{ localita ? (localita) : '' }}
            </span>
          </div>
        </div>
        <div class="col-16 header-country">
          <div class="contenitore-select">
            <div class="header-stato">
              {{ $t('indexRottame.stato') }}
            </div>
            <el-select v-model="country" placeholder="" @change="changeCountry">
              <el-option
                v-for="item in countries"
                :key="item"
                :label="$t('indexRottame')[item].toUpperCase()"
                :value="item">
              </el-option>
            </el-select>
          </div>
          <div class="contenitore-select" v-if="(typeOfUser === 'fornitore' && fornitori.length > 0)">
            <div class="header-stato">
              {{ $t('indexRottame.fornitore') }}
            </div>
            <el-select v-model="fornitore" placeholder="" @change="changeFornitore" :disabled="(fornitori.length < 2)">
              <el-option
                v-for="item in fornitori"
                :key="item.tipForn + item.codForn"
                :label="item.codForn"
                :value="item.tipForn + item.codForn">
                {{ (item.codForn + ' - ' + item.descForn) }}
              </el-option>
            </el-select>
          </div>
        </div>
      </div>

      <div class="row row-custom">
        <div class="col-xl-15 col-24 no-padding">
          <div class="row row-custom testata">
            <div class="card-testata col-xl-8 col-md-8 col-24 pointer">
              <dashboard-card-doppia :properties="conferme" @click.native="goToConferme"></dashboard-card-doppia>
            </div>
            <div class="card-testata col-xl-8 col-md-8 col-24">
              <dashboard-card :properties="viaggiPrenotati"></dashboard-card>
            </div>
            <div class="card-testata col-xl-8 col-md-8 col-24">
              <dashboard-card :properties="dichiarato"></dashboard-card>
            </div>
          </div>
          <div class="row row-custom centrale">
            <div class="col-xl-5 col-md-6">
              <card-piccola class="col-24" :properties="ricevuto"></card-piccola>
              <card-piccola class="col-24" :properties="viaggiante"></card-piccola>
              <card-piccola class="col-24" :properties="mancante"></card-piccola>
            </div>
            <div class="col-xl-11 col-md-10" style="padding-left: 0px">
              <div class="container-torta">

                <donut-chart
                  :title="($t('indexRottame.viaggiPrenotati').toUpperCase())"
                  :options="optionsTorta"
                  :chartData="rowsTorta"
                  :chartColumns="columnsTorta"
                  :isAdmin="isAdmin"
                ></donut-chart>

              </div>
            </div>
            <div class="col-xl-8 col-md-8 carosello" v-loading="loadingCarosello">
              <el-carousel arrow="never" :autoplay="false" indicator-position="outside" trigger="click" @change="changeScheda" v-if="(cards.length > 0)">
                <el-carousel-item v-for="scheda in nrSchede" :key="scheda">
                  <div class="card-stabilimento" v-for="item in cards" :key="(item.codSoc + ' - ' + item.codStab)">
                    <div class="scheda">
                      <div class="scheda-stab">
                        {{ item.desStab }}
                      </div>
                      <div class="scheda-nr-ordini">
                        {{ item.nrViaggiPren }}
                      </div>
                      <div class="scheda-label">
                        {{ $t('indexRottame.viaggi') }}
                      </div>
                      <div class="scheda-valore">
                        {{ item.pesoTot.replace(/\d(?=(?:\d{3})+$)/g, '$&.') + ' Kg' }}
                      </div>
                    </div>
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
        </div>
        <div class="col-xl-9 col-24">
          <div class="container-storico">
            <div class="col-24 titolo-storico">
              {{ $t('indexRottame.storicoViaggi').toUpperCase() }}
            </div>
            <div class="row row-custom">
              <div class="col-xl-12 col-lg-6 col-md-12">
                <div class="box-testata prenotati">
                  <div class="row row-custom">
                    <div class="col-16 box-label">
                      {{ $t('indexRottame.prenotati') }}
                    </div>
                    <div class="col-8 valore">
                      {{ storico.prenotati }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-12 col-lg-6 col-md-12">
                <div class="box-testata ricevuti">
                  <div class="row row-custom">
                    <div class="col-16 box-label">
                      {{ $t('indexRottame.ricevuti') }}
                    </div>
                    <div class="col-8 valore">
                      {{ storico.ricevuti }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-12 col-lg-6 col-md-12">
                <div class="box-testata eliminati">
                  <div class="row row-custom">
                    <div class="col-16 box-label">
                      {{ $t('indexRottame.eliminati') }}
                    </div>
                    <div class="col-8 valore">
                      {{ storico.eliminati }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-12 col-lg-6 col-md-12">
                <div class="box-testata contestati">
                  <div class="row row-custom">
                    <div class="col-16 box-label">
                      {{ $t('indexRottame.contestati') }}
                    </div>
                    <div class="col-8 valore">
                      {{ storico.contestati }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="grafico col-24">
              <div class="container-grafico">

                <area-chart
                  :title="('(' + $t('indexRottame.ultimiNMesi') + ')')"
                  :options="optionsStorico"
                  :chartData="rowsStorico"
                  :chartColumns="columnsStorico"
                  :isAdmin="isAdmin"
                ></area-chart>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row row-custom footer">
        <div class="col-xl-17 col-lg-15 col-24">
          <div class="container-footer">

            <column-chart
              :title="$t('indexRottame.situazioneViaggi').toUpperCase()"
              :options="optionsIsto"
              :chartData="rowsIsto"
              :chartColumns="columnsIsto"
              :isAdmin="isAdmin"
            ></column-chart>

          </div>
        </div>
        <div class="col-xl-7 col-lg-9 col-24">
          <div class="container-footer">
            <div class="col-24 titolo">
              {{ $t('indexRottame.viaggiPrenotati').toUpperCase() }}
            </div>
            <div class="col-24 subtitolo">
              {{ '(' + $t('indexRottame.prossimiNGiorni') + ')' }}
            </div>

            <el-table v-loading="loadingTabella"
              :data="sitViaggiFuturo"
              style="width: 100%">
              <el-table-column
                :label="($t('indexRottame.spedizione'))"
                min-width="100">

                <template slot-scope="scope">
                  <div class="name-wrapper" v-if="(scope.$index === 0)">
                    {{ $t('indexRottame.scaduto') }}
                  </div>
                  <div class="name-wrapper" v-else>
                    {{ formatData(scope.row.data, 'YYYYMMDD', 'DD/MM/YYYY') }}
                  </div>
                </template>

              </el-table-column>
              <el-table-column
                prop="nrViaggiPren" align="center" haeder-align="center"
                :label="($t('indexRottame.nrViaggi'))"
                min-width="80">
              </el-table-column>
              <el-table-column
                align="right" haeder-align="right"
                :label="($t('indexRottame.qta'))"
                min-width="80">

                  <template slot-scope="scope">
                    <div class="name-wrapper">
                      {{ scope.row.qtaTot.replace(/\d(?=(?:\d{3})+$)/g, '$&.') }}
                    </div>
                  </template>

              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import DashboardCard from '@/components/ServiceComponents/DashboardCard'
  import DashboardCardDoppia from '@/components/ServiceComponents/DashboardCardDoppia'
  import CardPiccola from '@/components/ServiceComponents/CardPiccola'
  import {bus} from '../Bus.js'
  import moment from 'moment'
  import ColumnChart from '../ServiceComponents/ColumnChart.vue'
  import DonutChart from '../ServiceComponents/DonutChart.vue'
  import AreaChart from '../ServiceComponents/AreaChart.vue'

export default {
  name: 'IndexRottame',
  props: ['contenitoreHeight'],
  components: {DashboardCard, DashboardCardDoppia, CardPiccola, ColumnChart, DonutChart, AreaChart},
  i18n: {
    messages: {
      it_IT: {
        indexRottame: {
          1: 'Italia',
          2: 'Francia',
          3: 'Spagna',
          4: 'Belgio',
          5: 'Germania',
          conferme: 'Conferme',
          viaggiPrenotati: 'Viaggi Prenotati',
          dichiarato: 'Dichiarato',
          ricevuto: 'Riscontrato',
          viaggiante: 'Viaggiante',
          mancante: 'Mancante',
          viaggi: 'Viaggi',
          storicoViaggi: 'Storico Viaggi',
          prenotati: 'Prenotati',
          ricevuti: 'Ricevuti',
          eliminati: 'Eliminati',
          contestati: 'Contestati',
          ultimiNMesi: 'Ultimi 12 mesi',
          situazioneViaggi: 'Situazione Viaggi',
          prossimiNGiorni: 'Prossimi 7 giorni',
          spedizione: 'Spedizione',
          nrViaggi: 'N. Viaggi',
          qta: 'Qta (Kg)',
          scaduto: 'Scaduto',
          stato: 'Stato: ',
          fornitore: 'Fornitore: '
        }
      },
      fr_FR: {
        indexRottame: {
          1: 'Italie',
          2: 'France',
          3: 'Espagne',
          4: 'Belgique',
          5: 'Allemagne',
          conferme: 'Confirmations',
          viaggiPrenotati: 'Voyages réservés',
          dichiarato: 'Déclaré',
          ricevuto: 'Reçu',
          viaggiante: 'En voyage',
          mancante: 'Manquant',
          viaggi: 'Voyages',
          storicoViaggi: 'Historique des voyages',
          prenotati: 'Réservé',
          ricevuti: 'Reçu',
          eliminati: 'Supprimé',
          contestati: 'Contesté',
          ultimiNMesi: '12 derniers mois',
          situazioneViaggi: 'Situation Voyages',
          prossimiNGiorni: '7 prochains jours',
          spedizione: 'Expédition',
          nrViaggi: 'N. Voyage',
          qta: 'Qté (Kg)',
          scaduto: 'Expiré',
          stato: 'Nation: ',
          fornitore: 'Fournisseur: '
        }
      },
      es_ES: {
        indexRottame: {
          1: 'Italia',
          2: 'Francia',
          3: 'España',
          4: 'Bélgica',
          5: 'Alemania',
          conferme: 'Confirmaciones',
          viaggiPrenotati: 'Viajes Reservados',
          dichiarato: 'Declarado',
          ricevuto: 'Recibido',
          viaggiante: 'En camino',
          mancante: 'Falta',
          viaggi: 'Viajes',
          storicoViaggi: 'Historico viajes',
          prenotati: 'Reservado',
          ricevuti: 'Recibido',
          eliminati: 'Suprimido',
          contestati: 'Contestados',
          ultimiNMesi: 'Últimos 12 meses',
          situazioneViaggi: 'Situacion Viajes',
          prossimiNGiorni: 'Próximos 7 dias',
          spedizione: 'Envío',
          nrViaggi: 'N. Viajes',
          qta: 'Cant (Kg)',
          scaduto: 'Caducado',
          stato: 'País: ',
          fornitore: 'Proveedor: '
        }
      },
      de_DE: {
        indexRottame: {
          1: 'Italien',
          2: 'Frankreich',
          3: 'Spanien',
          4: 'Belgien',
          5: 'Deutschland',
          conferme: 'Einkaufsbestaetigungen',
          viaggiPrenotati: 'Gebuchte Reisen',
          dichiarato: 'Deklariert',
          ricevuto: 'Bekommt',
          viaggiante: 'Unterwegs',
          mancante: 'Fehlende',
          viaggi: 'Reise',
          storicoViaggi: 'Zusammenfassung der Reisen',
          prenotati: 'Reserviert',
          ricevuti: 'Bekommt',
          eliminati: 'Geloescht',
          contestati: 'Reklamiert',
          ultimiNMesi: 'Letzen 12 Monaten',
          situazioneViaggi: 'Situation der Reisen',
          prossimiNGiorni: 'Naechste 7 Tage',
          spedizione: 'Transportart',
          nrViaggi: 'N. Reisen',
          qta: 'Anz (Kg)',
          scaduto: 'Abgelaufen',
          stato: 'Land: ',
          fornitore: 'Lieferant: '
        }
      },
      en_GB: {
        indexRottame: {
          1: 'Italy',
          2: 'France',
          3: 'Spain',
          4: 'Belgium',
          5: 'Germany',
          conferme: 'Confirmations',
          viaggiPrenotati: 'Travel Pre-ordered',
          dichiarato: 'Declared',
          ricevuto: 'Received',
          viaggiante: 'Traveling',
          mancante: 'Missing',
          viaggi: 'Travel',
          storicoViaggi: 'Travel History',
          prenotati: 'Booked',
          ricevuti: 'Received',
          eliminati: 'Deleted',
          contestati: 'Contested',
          ultimiNMesi: 'Last 12 months',
          situazioneViaggi: 'Travel situation',
          prossimiNGiorni: 'Next 7 days',
          spedizione: 'Shipment',
          nrViaggi: 'N. Travel',
          qta: 'Qty (Kg)',
          scaduto: 'Expired',
          stato: 'Country: ',
          fornitore: 'Supplier: '
        }
      }
    }
  },
  data () {
    return {
      loadingCarosello: true,
      loadingTabella: true,
      isAdmin: false,
      codLang: '',
      abilitazioni: [],
      countries: [],
      country: '',
      abilitatoGR: false,
      abilitatoSR: false,
      rangeConfermeDa: '',
      rangeConfermeA: '',
      conferme: {
        bgColorUp: 'linear-gradient(to right, #00635c, #02b1a6)',
        bgColorDown: '#48adb5',
        iconColorUp: '#fff',
        iconColorDown: '#fff',
        titleUp: '',
        titleDown: '',
        iconaUp: 'riv-conferme',
        iconaDown: '',
        valueUp: '0',
        valueDown: '0 Kg',
        typeDown: 'Numero'
      },
      viaggiPrenotati: {
        bgColor: 'linear-gradient(to right, #AC237F, #bb629f)',
        iconColor: '#fff',
        title: '',
        icona: 'riv-viaggiPrenotati',
        type: 'Numero',
        value: ''
      },
      dichiarato: {
        bgColor: 'linear-gradient(to right, #3e1844, #af55a8)',
        iconColor: '#fff',
        title: '',
        icona: 'riv-libra',
        type: 'Numero',
        value: ''
      },
      ricevuto: {
        title: '',
        value: ''
      },
      viaggiante: {
        title: '',
        value: ''
      },
      mancante: {
        title: '',
        value: ''
      },
      columnsTorta: [{
        'type': 'string',
        'label': 'Stabilimento'
      }, {
        'type': 'number',
        'label': 'Viaggi Prenotati'
      }],
      rowsTorta: [],
      optionsTorta: {
        height: 210,
        pieHole: 0.5,
        backgroundColor: '#fff',
        chartArea: {
          width: '100%',
          top: 10,
          height: 210,
          left: 10,
          bottom: 10
        },
        colors: ['#48adb5', '#bd3090', '#7d3d87', '#3f2a6d', '#2b6165', '#ccc', '#b5e2e6','#c1a9b9','#aca3ad','#665f75','#b97ccd'],
        fontName: 'os-regular',
        legend: {
          position: 'right',
          textStyle: {
            color: '#007c74',
            fontName: 'os-regular',
            fontSize: 12
          }
        }
      },
      nrSchede: 0,
      cards: [],
      viaggiPrenotatiData: [],
      storico: {
        prenotati: 0,
        eliminati: 0,
        contestati: 0,
        ricevuti: 0
      },
      columnsStorico: [
        {'type': 'string', 'label': 'Data'},
        {'type': 'number', 'label': 'Ricevuti'},
        {'type': 'number', 'label': 'Contestati'}
      ],
      rowsStorico: [],
      optionsStorico: {
        width: '100%',
        height: 205,
        chartArea: {
          height: '70%',
          width: '87%',
          left: 30
        },
        dataOpacity: 0.6,
        vAxis: {
          gridlines: {
            color: '#ccc',
            count: 8
          },
          minorGridlines: {
            color: '#fff'
          }
        },
        legend: {
          position: 'none',
          textStyle: {
            fontSize: 1,
            fontName: 'os-regular'
          }
        },
        colors: [ '#48adb5', '#7d3d87', '#bd3090', '#7d3d87']
      },
      columnsIsto: [
        {'type': 'string', 'label': 'Data'},
        {'type': 'number', 'label': 'Prenotati'},
        {'type': 'number', 'label': 'Ricevuti'},
        {'type': 'number', 'label': 'Contestati'},
        {'type': 'number', 'label': 'Eliminati'}
      ],
      rowsIsto: [],
      optionsIsto: {
        seriesType: 'bars',
        height: 300,
        bar: {
          groupWidth: 60
        },
        chartArea: {
          width: '78%',
          left: 40,
          top: 30,
          height: '80%'
        },
        vAxis: {
          gridlines: {
            color: '#ccc',
            count: 6
          },
          minorGridlines: {
            color: '#fff'
          }
        },
        colors: ['#bd3090', '#48adb5', '#7d3d87', '#445245'],
        legend: {
          textStyle: {
            color: '#007c74',
            fontName: 'os-regular',
            fontSize: 13
          }
        }
      },
      sitViaggiFuturo: [],
      abilitazioni: [],
      codForn: '',
      typeOfUser: '',
      fornitore: '',
      fornitori: [],
      localita: ''
    }
  },
  watch: {
    '$mq.resize': 'onResize',
  },
  computed: {
    showDashboard: function () {
      let path = this.$route.path
      return (path === '/rottame' || path === '/rottame/')
    },
    ifArrow: function () {
      if (this.nrSchede > 1) {
        return 'always'
      } else {
        return 'never'
      }
    }
  },
  activated: function () {
    this.init()
  },
  mounted: function () {
    bus.$on('Header_SetCodFornAdmin', () => {
      this.resetDati()

      if (localStorage.hasOwnProperty('amministrazione')) {
        this.$set(this, 'codForn', (JSON.parse(localStorage.getItem('amministrazione')))['TRAACQ'][this.country])
      } else {
        this.$set(this, 'codForn', '')
      }

      this.getFornitoreInfo()
    })
    bus.$on('TRAACQ_ChangeCountryFromApp', () => {
      this.changeCountry(localStorage.getItem('TRAACQ_country'), true)
    })
    bus.$on('changeLanguage', () => {
      this.$set(this, 'codLang', sessionStorage.getItem('codLang'))
      this.$nextTick(() => {
        this.setTraduzioni()
      })
    })
  },
  methods: {
    resetDati: function () {
      this.$set(this, 'loadingCarosello', true)
      this.$set(this, 'loadingTabella', true)
      this.$set(this, 'isAdmin', false)
      // this.country = ''
      this.$set(this, 'viaggiPrenotatiData', [])
      this.$set(this, 'rangeConfermeDa', '')
      this.$set(this, 'rangeConfermeA', '')
      this.$set(this.conferme, 'valueUp', '')
      this.$set(this.conferme, 'valueDown', '')
      this.$set(this.viaggiPrenotati, 'value', '')
      this.$set(this.dichiarato, 'value', '')
      this.$set(this.ricevuto, 'value', '')
      this.$set(this.viaggiante, 'value', '')
      this.$set(this.mancante, 'value', '')
      this.$set(this, 'nrSchede', 0)
      this.$set(this, 'cards', [])
      this.$set(this, 'rowsTorta', [])
      this.$set(this, 'rowsIsto', [])
      this.$set(this, 'sitViaggiFuturo', [])
      this.$set(this.storico, 'prenotati', '')
      this.$set(this.storico, 'ricevuti', '')
      this.$set(this.storico, 'eliminati', '')
      this.$set(this.storico, 'contestati', '')
      this.$set(this, 'rowsStorico', [])
      this.$set(this, 'localita', '')
    },
    init: function () {
      this.resetDati()

      this.$set(this, 'codLang', sessionStorage.getItem('codLang'))
      setTimeout(() => {
        this.getCountries()
        this.setTraduzioni()
      }, 300)
    },
    goToConferme: function () {
      this.$router.push({ name: 'GestioneRottameConferme' })
    },
    formatData: function (date, formatIn, formatOut) {
      if (moment(date, formatIn).isValid()) {
        return moment(date, formatIn).format(formatOut)
      } else {
        return date
      }
    },
    setTraduzioni: function () {
      this.conferme.titleUp = this.$t('indexRottame.conferme')
      this.viaggiPrenotati.title = this.$t('indexRottame.viaggiPrenotati')
      this.dichiarato.title = this.$t('indexRottame.dichiarato') + ' (Kg)'
      this.ricevuto.title = this.$t('indexRottame.ricevuto')
      this.viaggiante.title = this.$t('indexRottame.viaggiante')
      this.mancante.title = this.$t('indexRottame.mancante')

      let columnsIsto = [
        {'type': 'string', 'label': 'Data'},
        {'type': 'number', 'label': this.$t('indexRottame.prenotati')},
        {'type': 'number', 'label': this.$t('indexRottame.ricevuti')},
        {'type': 'number', 'label': this.$t('indexRottame.contestati')},
        {'type': 'number', 'label': this.$t('indexRottame.eliminati')}
      ]
      this.$set(this, 'columnsIsto', columnsIsto)

      let columnsStorico = [
        {'type': 'string', 'label': 'Data'},
        {'type': 'number', 'label': this.$t('indexRottame.ricevuti')},
        {'type': 'number', 'label': this.$t('indexRottame.contestati')}
      ]
      this.$set(this, 'columnsStorico', columnsStorico)
    },
    onResize: function () {
      if (this.$mq.above('width', 1249)) {
        this.$set(this.optionsStorico.chartArea, 'width', '87%')
        this.$set(this.optionsStorico.chartArea, 'left', 30)
        this.$set(this.optionsIsto.chartArea, 'width', '78%')
        this.$set(this.optionsIsto.chartArea, 'left', 40)
      } else if (this.$mq.above('width', 991) && this.$mq.below('width', 1250)) {
        this.$set(this.optionsStorico.chartArea, 'width', '90%')
        this.$set(this.optionsStorico.chartArea, 'left', 50)
        this.$set(this.optionsIsto.chartArea, 'width', '70%')
        this.$set(this.optionsIsto.chartArea, 'left', 40)
      } else if (this.$mq.above('width', 767) && this.$mq.below('width', 992)) {
        this.$set(this.optionsStorico.chartArea, 'width', '90%')
        this.$set(this.optionsStorico.chartArea, 'left', 35)
        this.$set(this.optionsIsto.chartArea, 'width', '72%')
        this.$set(this.optionsIsto.chartArea, 'left', 40)
      } else {
        this.$set(this.optionsStorico.chartArea, 'width', '86%')
        this.$set(this.optionsStorico.chartArea, 'left', 30)
        this.$set(this.optionsIsto.chartArea, 'width', '60%')
        this.$set(this.optionsIsto.chartArea, 'left', 40)
      }
    },
    changeScheda: function (newIndex, oldIndex) {
      this.$set(this, 'cards', [])
      for (let i = (newIndex * 4); i <= (newIndex * 4 + 3); i++) {
        let obj = this.viaggiPrenotatiData[i]
        if (obj !== null && obj !== undefined) {
          this.cards.push(this.viaggiPrenotatiData[i])
        }
      }
    },
    getFornitoreInfo: function () {
      this.$http.get('buonidiscarico/info', {
        params: {
          codLang: this.codLang,
          country: this.country
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            this.$set(this, 'typeOfUser', response.body.attrib.typeOfUser)
            if (response.body.attrib.typeOfUser === 'fornitore') {
              this.$set(this, 'fornitori', response.body.data)
              if (sessionStorage.hasOwnProperty('TRAACQ_fornitore')) {
                this.$set(this, 'fornitore', sessionStorage.getItem('TRAACQ_fornitore'))
                this.$set(this, 'codForn', sessionStorage.getItem('TRAACQ_fornitore'))
              } else {
                this.$set(this, 'fornitore', response.body.data[0].tipForn + response.body.data[0].codForn)
                this.$set(this, 'codForn', response.body.data[0].tipForn + response.body.data[0].codForn)
                sessionStorage.setItem('TRAACQ_fornitore', this.codForn)
              }
            } else if (response.body.attrib.typeOfUser === 'admin') {
              if (localStorage.hasOwnProperty('amministrazione')) {
                this.$set(this, 'codForn', (JSON.parse(localStorage.getItem('amministrazione')))['TRAACQ'][this.country])
              } else {
                this.$set(this, 'codForn', '')
              }
            }
  
            this.getViaggiPren()
            this.getSitViaggiStorico()
            this.getSitViaggiFuturo()
            this.getStoricoViaggi()
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
        })
    },
    changeFornitore: function () {
      this.$set(this, 'codForn', this.fornitore)
      this.$set(this, 'loadingCarosello', true)
      this.$set(this, 'loadingTabella', true)
      sessionStorage.setItem('TRAACQ_fornitore', this.codForn)
      sessionStorage.removeItem('WGR_form')
      sessionStorage.removeItem('WGR_conf')
      sessionStorage.removeItem('WSR_form')
      this.$store.replaceState({
        trattativa: {},
        trattativaForm: {},
        nuovaTrattativa: false,
        duplicaTrattativa: false
      })
      this.resetDati()
      this.getViaggiPren()
      this.getSitViaggiStorico()
      this.getSitViaggiFuturo()
      this.getStoricoViaggi()
    },
    getCountries: function () {
      this.$http.get('portale/menu', {
        params: {
          codLang: this.codLang
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            this.abilitazioni = response.body.data
            for (let i = 0; i < this.abilitazioni.length; i++) {
              let obj = this.abilitazioni[i]
              if (obj.area === 'TRAACQ') {
                let array = []
                for (let j = 0; j < obj.apps.length; j++) {
                  let app = obj.apps[j]
                  let appCountries = JSON.parse(app.countries)
                  for (let k = 0; k < appCountries.length; k++) {
                    let country = appCountries[k]
                    if (array.indexOf(country) < 0) {
                      array.push(country)
                    }
                  }
                }

                // Popolo gli stati a cui sono abilitato e seleziono lo stato salvato nel localStorage (se è tra quelli a cui sono abilitato)
                this.$set(this, 'countries', array)
                if (localStorage.hasOwnProperty('TRAACQ_country') && this.countries.indexOf(parseInt(localStorage.getItem('TRAACQ_country'))) >= 0) {
                  this.$set(this, 'country', parseInt(localStorage.getItem('TRAACQ_country')))
                } else {
                  this.$set(this, 'country', array[0])
                  localStorage.setItem('TRAACQ_country', array[0])
                }
  
                bus.$emit('Header_ChangeAdmin', this.country, 'TRAACQ')

                this.getFornitoreInfo()
              }
            }
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
        })
    },
    changeCountry: function (country, ifChangeCountryFromApp) {
      this.$set(this, 'country', parseInt(country))
      localStorage.setItem('TRAACQ_country', country)
      if (!ifChangeCountryFromApp) {
        sessionStorage.removeItem('WGR_form')
        sessionStorage.removeItem('WGR_conf')
        sessionStorage.removeItem('WSR_form')
      }
      bus.$emit('TRAACQ_ChangeCountryFromDsh')
      if (localStorage.hasOwnProperty('amministrazione')) {
        this.$set(this, 'codForn', (JSON.parse(localStorage.getItem('amministrazione')))['TRAACQ'][this.country])
      } else {
        this.$set(this, 'codForn', '')
      }
      bus.$emit('Header_ChangeAdmin', this.country, 'TRAACQ')

      this.resetDati()
      if (!ifChangeCountryFromApp) {
        sessionStorage.removeItem('TRAACQ_fornitore')
      }
      this.$store.replaceState({
        trattativa: {},
        trattativaForm: {},
        nuovaTrattativa: false,
        duplicaTrattativa: false
      })

      this.getFornitoreInfo()
    },
    getViaggiPren: function () {
      this.$http.get('dashboardrot/viaggipren', {
        params: {
          codLang: this.codLang,
          country: this.country,
          codForn: this.codForn.substring(1),
          tipoForn: this.codForn.substring(0, 1)
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            let attrib = response.body.attrib
            let data = response.body.data

            this.$set(this, 'viaggiPrenotatiData', data)

            this.rangeConfermeDa = (attrib.dataRifIn !== '00000000') ? moment(attrib.dataRifIn, 'YYYYMMDD').format('DD/MM/YYYY') : ''
            this.rangeConfermeA = (attrib.dataRifFin !== '00000000') ? moment(attrib.dataRifFin, 'YYYYMMDD').format('DD/MM/YYYY') : ''

            this.$set(this, 'localita', attrib.localita)

            this.$set(this.conferme, 'valueUp', attrib.nrConferme)
            this.$set(this.conferme, 'valueDown', attrib.ordinato.replace(/\d(?=(?:\d{3})+$)/g, '$&.') + ' Kg')

            this.$set(this.viaggiPrenotati, 'value', attrib.nrViaggiPren)

            this.$set(this.dichiarato, 'value', attrib.dichiarato.replace(/\d(?=(?:\d{3})+$)/g, '$&.'))

            this.$set(this.ricevuto, 'value', attrib.ricevuto.replace(/\d(?=(?:\d{3})+$)/g, '$&.') + ' Kg')
            this.$set(this.viaggiante, 'value', attrib.viaggiante.replace(/\d(?=(?:\d{3})+$)/g, '$&.') + ' Kg')
            this.$set(this.mancante, 'value', attrib.mancante.replace(/\d(?=(?:\d{3})+$)/g, '$&.') + ' Kg')

            this.nrSchede = (data.length % 4 > 0) ? (parseInt(data.length / 4) + 1) : (parseInt(data.length / 4))
            let i = 0
            this.$set(this, 'cards', [])
            while (i < 4) {
              if (data[i] !== undefined) {
                this.cards.push(data[i])
              }
              i++
            }

            let arrayTemp = []
            for (let i = 0; i < data.length; i++) {
              let obj = data[i]
              let array = [obj.desStab, parseInt(obj.nrViaggiPren)]
              arrayTemp.push(array)
            }
            this.$set(this, 'rowsTorta', arrayTemp)
          } else {
            if (['0101', '0002'].indexOf(response.body.msg[0].msgId) < 0) {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            } else {
              this.isAdmin = true
            }
          }
          this.loadingCarosello = false
        })
    },
    getSitViaggiStorico: function () {
      let dataDa = moment(new Date(new Date().getTime() - (6 * 24 * 60 * 60 * 1000))).format('YYYYMMDD')
      let dataA = moment(new Date()).format('YYYYMMDD')

      this.$http.get('dashboardrot/sitviaggi', {
        params: {
          codLang: this.codLang,
          country: this.country,
          codForn: this.codForn.substring(1),
          tipoForn: this.codForn.substring(0, 1),
          dataDa: dataDa,
          dataA: dataA
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            let data = response.body.data

            this.$set(this, 'rowsIsto', [])
            let array = []
            data.forEach((item) => {
              let arrayTemp = [moment(item.data, 'YYYYMMDD').format('DD/MM'), parseInt(item.nrViaggiPren), parseInt(item.nrViaggiRicev), parseInt(item.nrViaggiCont), parseInt(item.nrViaggiElim)]
              array.push(arrayTemp)
            })
            this.$set(this, 'rowsIsto', array)
          } else {
            if (['0101', '0002'].indexOf(response.body.msg[0].msgId) < 0) {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            } else {
              this.isAdmin = true
            }
          }
        })
    },
    getSitViaggiFuturo: function () {
      let dataDa = moment(new Date(new Date().getTime() + (24 * 60 * 60 * 1000))).format('YYYYMMDD')
      let dataA = moment(new Date(new Date().getTime() + (7 * 24 * 60 * 60 * 1000))).format('YYYYMMDD')

      this.$http.get('dashboardrot/sitviaggi', {
        params: {
          codLang: this.codLang,
          country: this.country,
          codForn: this.codForn.substring(1),
          tipoForn: this.codForn.substring(0, 1),
          dataDa: dataDa,
          dataA: dataA
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            let obj = {
              data: 'Scaduto',
              nrViaggiPren: response.body.attrib.nrViaggiScad,
              qtaTot: response.body.attrib.qtaViaggiScad.replace(/\d(?=(?:\d{3})+$)/g, '$&.'),
            }
            let newArray = [obj].concat(response.body.data)
            this.$set(this, 'sitViaggiFuturo', newArray)
          } else {
            if (['0101', '0002'].indexOf(response.body.msg[0].msgId) < 0) {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
          }
          this.loadingTabella = false
        })
    },
    getStoricoViaggi: function () {
      this.$http.get('dashboardrot/storicoviaggi', {
        params: {
          codLang: this.codLang,
          country: this.country,
          codForn: this.codForn.substring(1),
          tipoForn: this.codForn.substring(0, 1),
          nrMesi: 12
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            let attrib = response.body.attrib
            let data = response.body.data

            this.$set(this.storico, 'prenotati', attrib.nrViaggiPren)
            this.$set(this.storico, 'ricevuti', attrib.nrViaggiRicev)
            this.$set(this.storico, 'eliminati', attrib.nrViaggiElim)
            this.$set(this.storico, 'contestati', attrib.nrViaggiCont)

            this.$set(this, 'rowsStorico', [])
            let array = []
            data.forEach((item) => {
              let arrayTemp = [moment(item.data, 'YYYYMMDD').format('MM/YY'), parseInt(item.nrViaggiRicev), parseInt(item.nrViaggiCont)]
              array.push(arrayTemp)
            })
            this.$set(this, 'rowsStorico', array)
          } else {
            if (['0101', '0002'].indexOf(response.body.msg[0].msgId) < 0) {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            } else {
              this.isAdmin = true
            }
          }
        })
    }
  }
}
</script>

<style lang="less">
@import "../../assets/less/general.less";

.index-rottame {
  .dashboard {
    -webkit-box-shadow: 0 0 10px 2px #cecece;
    -moz-box-shadow: 0 0 10px 2px #cecece;
    box-shadow: 0 0 10px 2px #cecece;
    background-color: #ffffff;
    margin: auto;
    overflow-x: hidden;
    margin-top: 25px;
    .range-conferme {
      .set-font(@color: @greenRiva, @size: 16px);
      margin-top: 17px;
      letter-spacing: 1px;
      .localita {
        margin-left: 20px;
        .set-font(@size: 16px, @family: 'os-semibold', @color: @greenRiva);
      }
    }
    .header-country {
      height: 45px;
      text-align: right;
      margin-top: 5px;
      .contenitore-select {
        display: inline-block;
        margin-left: 20px;
        .header-stato {
          .set-font(@size: 17px, @family: 'os-regular');
          text-align: right;
          line-height: 30px;
          display: inline-block;
          margin-right: 10px;
        }
        .el-select {
          width: 230px;
          display: inline-block;
          .el-input {
            .el-input__inner {
              border-radius: 0;
              border: 0;
              border-bottom: 1px solid #666;
              height: 35px;
              .set-font(@size: 18px, @family: 'os-semibold', @color: #bd3090);
              letter-spacing: 4px;
            }
            .el-select__caret {
              color: #666;
              font-size: 22px;
            }
          }
        }
      }
    }
    .testata {
      .card-testata {
        margin-bottom: 10px;
      }
    }
    .centrale {
      // margin-top: 10px;
      margin-bottom: 10px;
      .container-torta {
        margin-top: 5px;
        border: 1px solid #e7e7e7;
        border-radius: 4px;
        -moz-box-shadow: 0px 0px 13px 1px #e7e7e7;
        -webkit-box-shadow: 0px 0px 13px 1px #e7e7e7;
        box-shadow: 0px 0px 13px 1px #e7e7e7;
        padding: 0px 5px !important;
        .titolo-torta {
          .set-font(@size: 13px; @weight: bold; @color: @greenRiva);
          letter-spacing: 3px;
          margin-top: 5px;
        }
      }
      .carosello {
        // height: 315px;
        margin-top: 5px;
        // margin-bottom: 15px;
        .el-carousel {
          height: 100%;
          .el-carousel__container {
            height: 237px;
            width: 100%;
            button:focus {
              outline: 0px auto;
            }
            .el-carousel__arrow {
              background-color: #fff;
              color: #ccc;
              font-size: 30px;
            }
            .el-carousel__item {
              width: 100%;
              .card-stabilimento {
                height: 48%;
                width: 50%;
                display: inline-block;
                margin-bottom: 2px;
                .scheda {
                  border: 1px solid #e7e7e7;
                  border-radius: 4px;
                  // -moz-box-shadow: 0px 0px 13px 1px #e7e7e7;
                  // -webkit-box-shadow: 0px 0px 13px 1px #e7e7e7;
                  // box-shadow: 0px 0px 13px 1px #e7e7e7;
                  width: 92%;
                  margin: auto;
                  height: 110px;
                  text-align: center;
                  .scheda-stab {
                    margin-top: 8px;
                    .set-font(@size: 14px; @color: #48adb5);
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  }
                  .scheda-nr-ordini {
                    margin-top: 6px;
                    .set-font(@size: 33px; @color: #bd3090);
                    line-height: 30px;
                  }
                  .scheda-label {
                    .set-font(@size: 12px; @color: #bd3090);
                  }
                  .scheda-valore {
                    margin-top: 5px;
                    .set-font(@size: 12px; @color: #3f2a6d);
                  }
                }
              }
            }
          }
          .el-carousel__indicators {
            height: 10px;
            line-height: 0px;
            .el-carousel__indicator {
              padding: 3px 0px;
            }
          }
        }
      }
    }
    .container-storico {
      background-color: #e7e7e7;
      border-radius: 5px;
      border: 1px solid #ccc;
      height: 390px;
      width: 100%;
      .titolo-storico {
        .set-font(@color: @greenRiva, @size: 17px);
        letter-spacing: 2px;
        margin-top: 7px;
      }
      .box-testata {
        height: 30px;
        margin-top: 10px;
        border-radius: 5px;
        opacity: 0.6;
        line-height: 30px;
        .box-label {
          .set-font(@color: @white, @size: 15px);
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .valore {
          .set-font(@color: @white, @size: 15px);
          text-align: right;
          padding-right: 15px;
          padding-left: 0px;
        }
        &.prenotati {
          background-color: #bd3090;
        }
        &.eliminati {
          background-color: #445245;
        }
        &.ricevuti {
          background-color: #48adb5;
        }
        &.contestati {
          background-color: #7d3d87;
        }
      }
      .grafico {
        margin-top: 12px;
        .container-grafico {
          width: 100%;
          height: 250px;
          border-radius: 5px;
          background-color: @white;
          // padding-top: 15px;
          .testata {
            text-align: center;
            .set-font(@color: #666, @size: 11px);
            font-style: italic;
          }
        }
      }
    }
    .footer {
      margin-top: 15px;
      margin-bottom: 15px;
      height: 350px;
      .container-footer {
        //padding-top: 10px;
        border-radius: 4px;
        -moz-box-shadow: 0px 0px 13px 1px #e7e7e7;
        -webkit-box-shadow: 0px 0px 13px 1px #e7e7e7;
        box-shadow: 0px 0px 13px 1px #e7e7e7;
        height: 100%;
        .titolo {
          .set-font(@color: @greenRiva, @size: 14px, @family: 'os-semibold');
          letter-spacing: 2px;
          line-height: 35px;
        }
        .subtitolo {
          margin-top: 5px;
          .set-font(@color: #666, @size: 11px);
          text-align: center;
          font-style: italic;
        }

        .el-table::before {
          height: 0px;
        }
        .el-table {
          margin-top: 5px;
          border-bottom: none;
          max-height: 330px;
          overflow: auto;
          .el-table__empty-text {
            margin-top: 15px;
          }
          .el-table__header {
            border-bottom: 1px solid @greenRiva;
            thead {
              th {
                padding: 5px 0px 0px 0px;
                .cell {
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  padding-left: 10px !important;
                  .set-font(@color: @greenRiva, @size: 13px, @family: 'os-semibold');
                }
              }
            }
          }
          .el-table__body {
            tbody {
              tr {
                td {
                  padding-top: 4px;
                  padding-bottom: 4px;
                  .cell {
                    .set-font(@size: 12px, @color: #606266);
                  }
                  -webkit-transition: none;
                  transition: none;
                }
              }
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1249px) and (min-width: 992px) {
  .index-rottame {
    .dashboard {
      .container-storico {
        height: 350px;
      }
    }
  }
}

@media screen and (max-width: 991px) and (min-width: 768px) {
  .index-rottame {
    .dashboard {
      .range-conferme {
        .set-font(@color: @oroRiva, @size: 13px);
        margin-top: 22px;
        letter-spacing: 0px;
        .localita {
          .set-font(@size: 13px, @family: 'os-semibold', @color: @oroRiva);
        }
      }
    }
  }
}

@media screen and (max-width: 767px) {
  .index-rottame {
    .dashboard {
      .range-conferme {
        .set-font(@color: @oroRiva, @size: 13px);
        margin-top: 10px;
        letter-spacing: 0px;
        line-height: 15px;
        .localita {
          .set-font(@size: 13px, @family: 'os-semibold', @color: @oroRiva);
        }
      }
      .container-storico {
        height: 470px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Rottame/IndexRottame.vue